import {
  useProductsFilter,
  ArrayFilterKeys,
} from '../../../../../Context/ProductsFilterContext';
import styles from './FilterActiveTags.module.scss?module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

interface FilterActiveTagsProps {
  filterKeys: ArrayFilterKeys[];
}

const FilterActiveTags = ({ filterKeys }: FilterActiveTagsProps) => {
  const { toggleArrayFilter, activeFiltersWithLabels } = useProductsFilter();

  const tags = filterKeys.flatMap((key) =>
    (activeFiltersWithLabels[key] ?? []).map((opt) => ({
      ...opt,
      filterKey: key,
    }))
  );

  if (tags.length === 0) return null;

  return (
    <div className={styles.TagsRow} role="list" aria-label="Active filters">
      {tags.map(({ name, value, filterKey }) => (
        <button
          key={`${filterKey}-${value}`}
          type="button"
          role="listitem"
          className={styles.Tag}
          onClick={() => toggleArrayFilter(filterKey, value)}
          aria-label={`Remove filter: ${name}`}
        >
          <span>{name}</span>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      ))}
    </div>
  );
};

export default FilterActiveTags;
